module.exports = __webpack_public_path__ + "dist/media/paypal.86487b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art-details/payment/paypal.png
// module id = 391
// module chunks = 0